// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__19NCq","l4":"styles_l4__nqqpp","redir":"styles_redir__1vNe0"};